import React from 'react'
import PropTypes from 'prop-types'
import Image from 'next/image'

import { Column, Section } from '@/components/layout'
import BuyTry from '@/components/blocks/BuyTry'
import { Text } from '@/components/common'
import arrowRightImg from '@/assets/features-potential/arrow-right.png'
import arrowLeftImg from '@/assets/features-potential/arrow-left.png'

import styles from './FeaturesPotentialHeader.module.scss'

const FeaturesPotentialHeader = ({
  altImgOne,
  altImgTwo,
  canTry = true,
  descriptionImgOne,
  descriptionImgTwo,
  pathImgOne,
  pathImgTwo,
  skuValue = 'neatyr',
  smallPrint,
  subtitle,
  title,
}) => (
  <Section bgForeground>
    <Column className="w-full">
      <div className={styles.heroHolder}>
        <Text.H1 brandSecondary size="large">{ title }</Text.H1>
        <Text.P className={styles.tagline} onTint>{ subtitle }</Text.P>
        <BuyTry buySku={skuValue} canTry={canTry} marginTop={32} noOutline />
        <Text.P className={styles.smallText} onTint>{ smallPrint }</Text.P>
      </div>

      <div className={styles.heroImgSection}>
        <div className={styles.leftImg}>
          <Text.P onTint>{ descriptionImgOne }</Text.P>
          <Image alt="Arrow right" className={styles.hideMobile} src={arrowRightImg} />
          <Image alt={altImgOne} src={pathImgOne} style={{ height: 'auto' }} />
        </div>
        <div className={styles.rightImg}>
          <div className={styles.description}>
            <Text.P onTint>{ descriptionImgTwo }</Text.P>
            <Image alt="Arrow right" className={styles.hideMobile} src={arrowLeftImg} style={{ height: 'auto' }} />
          </div>
          <Image alt={altImgTwo} src={pathImgTwo} style={{ height: 'auto' }} />
        </div>
      </div>
    </Column>
  </Section>
)

FeaturesPotentialHeader.propTypes = {
  altImgOne: PropTypes.string,
  altImgTwo: PropTypes.string,
  canTry: PropTypes.bool,
  descriptionImgOne: PropTypes.string,
  descriptionImgTwo: PropTypes.string,
  pathImgOne: PropTypes.string,
  pathImgTwo: PropTypes.string,
  skuValue: PropTypes.string,
  smallPrint: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
}

export default FeaturesPotentialHeader
